import React, { Component } from "react";
import "./LeftColumn.css";

import { Grid, Image, Segment, GridRow } from 'semantic-ui-react'

import StoryMenu from "../../components/Stories/MainMenu/MainMenu";
import Moto from "../../components/Stories/Moto/Moto";

import { injectIntl, defineMessages } from "react-intl";

import blackBackground from "./images/net.jpg"
import whiteBackground from "./images/net.jpg"
import YouTubePlayer from "../../components/YouTubePlayer/YouTubePlayer";

const messages = defineMessages({
  myStory: {
    id: 'app.general.tellMyStory',
    defaultMessage: 'Tell my story...'
  },
})

//{formatMessage(messages.myStory)}

const inlineStyle = {
  // "backgroundImage": `url(${blackBackground})`,
  "backgroundColor": "black",
  "backgroundSize": "cover",
  "backgroundRepeat": "no-repeat",
  "backgroundPosition": "center",
  "minHeight": "250px"
};



class LeftColumn extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return false
}

  render() {
    const { intl: { formatMessage } } = this.props;
    return (
      <Grid.Column width={5} style={inlineStyle}>

        {/* <Segment >
          <StoryMenu />
        </Segment> */}
        {/* <div style={{ "margin-bottom": "20%", "bottom": "0", "position": "absolute" }}>
          <StoryMenu />
        </div> */}

        <div style={{ "position": "relative" }}>
          <div style={{ "position": "absolute", "bottom": "0", "width": "100%" }}>
            <Moto />
            <YouTubePlayer />
          </div>
        </div>
      </Grid.Column>
    );
  }
}

export default injectIntl(LeftColumn);
